import { Box, Typography, styled } from "@mui/material";
import * as Form from '../../../../../../Components/Form';

export const TextHeader = styled(Typography)(({ theme }) => (props) => ({
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '20px',
    color: theme.palette.mode === "light" ? theme.palette.text.light :
        theme.palette.text.dark,
    [theme.breakpoints.down('sm')]: {
        fontSize: '12px'
    }
}))
export const Section = styled(Box)(({ theme }) => (props) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
}))
export const InputTExtFa = styled(Form.InputFail)(({ theme }) => (props) => ({
    [theme.breakpoints.down('sm')]: {
        "& .MuiInputBase-root ": {
            width: '100%'
        }
    }
}))